import { render, staticRenderFns } from "./YouAndMeTextWooCommerce.vue?vue&type=template&id=2c42d7e2&scoped=true&"
import script from "./YouAndMeTextWooCommerce.vue?vue&type=script&lang=js&"
export * from "./YouAndMeTextWooCommerce.vue?vue&type=script&lang=js&"
import style0 from "./YouAndMeTextWooCommerce.vue?vue&type=style&index=0&id=2c42d7e2&lang=scss&scoped=true&"
import style1 from "./YouAndMeTextWooCommerce.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c42d7e2",
  null
  
)

export default component.exports